import { lazy } from 'react';
import i18next from 'i18next';
import { BotActivityIcon } from '@shared/ui/icons';
import permissions from '@shared/config/permissions';

const BotActivities = lazy(() => import('@pages/bot-activities'));

// const BOT_ACTIVITY_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/botActivity',
//   exact: true,
//   additional: {
//     component: BotActivities,
//     protected: true,
//     title: i18next.t('titles:botActivities'),
//     icon: BotActivityIcon,
//     permission: permissions.ADMIN_PATIENT_IMPORT,
//   },
// };

const BOT_ACTIVITY_ROUTE_LIST = {
  path: '/:currentAccountUuid/botActivity',
  exact: true,
  additional: {
    component: BotActivities,
    protected: true,
    title: i18next.t('titles:botActivities'),
    icon: BotActivityIcon,
    permission: permissions.ADMIN_PATIENT_IMPORT,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.botActivities || 'Bot Activities',
    },
  },
};

export const BOT_ACTIVITY_ROUTES = {
  // ------- For child accounts ------
  // listDS: BOT_ACTIVITY_ROUTE_LIST_DS,

  // ------- For current accounts ------
  list: BOT_ACTIVITY_ROUTE_LIST,
};
